import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import CancelIcon from '@material-ui/icons/Cancel';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import globals from '../../../globals/communityGlobals';

const activitiesLocale = globals.getAreas(['nonPatientActivityTypes', 'error']);

export default function NonPatientActivityTypeEdit({ model, eventHandlers }) {
  const [state, setState] = useState({ canSubmit: false, name: model.name, errorMsg: '' });

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <h6>{activitiesLocale.getMsg(`editTitle`)}</h6>
            </Box>
            <Box>
              <IconButton onClick={eventHandlers.closePanels}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const isNameValid = name => {
    const errorMsg = activitiesLocale.getMsg('validationMaxLength', ['50']);

    if (name.length > 50) {
      setState({ ...state, name, errorMsg, canSubmit: false });
    } else {
      setState({
        ...state,
        name,
        canSubmit: name.length > 0,
        errorMsg: '',
      });
    }
  };

  const save = () => {
    if (state.canSubmit) {
      eventHandlers.submitAction({ Id: model.id, Name: state.name });
    }
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '450px' }}>
          {headerRender()}

          <div className="sidePanel-content content-top-padding">
            <div className="form-row-100">
              <TextField
                required
                fullWidth
                value={state.name}
                error={state.errorMsg.length > 0}
                helperText={state.errorMsg}
                placeholder={'Enter name'}
                onChange={e => isNameValid(e.target.value)}
              />
            </div>
          </div>

          <div className="sidePanel-footer">
            <div className="sidePanel-buttons">
              <div className="sidePanel-BackButton">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={eventHandlers.closePanels}
                  style={{ marginRight: '10px' }}
                >
                  Back
                </Button>
              </div>
              <div className="sidePanel-saveButton form-row-100 align-end">
                <Button variant="contained" color="primary" type="submit" disabled={!state.canSubmit} onClick={save}>
                  Edit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    </section>
  );
}

// import React from 'react';
// import PropTypes from 'prop-types';

// import DefaultPageWraper from '../../../containers/PageStructure/DefaultPageWrapper/DefaultPageWrapperContainer';
// import Spinner from '../../../components/common/Spinner/Spinner';

// import NonPatientActivityTypeForm, { actionTypes } from './../NonPatientActivityTypes/NonPatientActivityTypeForm';
// import { ActivityTypePropType } from '../../../propTypes/entities/activityType';

// class NonPatientActivityTypeEdit extends React.Component {
//   componentDidMount() {
//     this.props.getActivityType(this.props.match.params.id);
//   }
//   render() {
//     const { submitAction, activityType, pageTitle, navigate } = this.props;

//     return (
//       <DefaultPageWraper pageTitle={pageTitle}>
//         {this.props.isFetching || !this.props.activityType ? (
//           <Spinner />
//         ) : (
//           <NonPatientActivityTypeForm
//             activityType={activityType}
//             actionType={actionTypes.edit}
//             submitAction={submitAction}
//             navigate={navigate}
//           />
//         )}
//       </DefaultPageWraper>
//     );
//   }
// }

// NonPatientActivityTypeEdit.defaultProps = {
//   activityType: null,
// };

// NonPatientActivityTypeEdit.propTypes = {
//   pageTitle: PropTypes.string.isRequired,
//   activityType: ActivityTypePropType,
//   isFetching: PropTypes.bool.isRequired,
//   match: PropTypes.shape({
//     params: PropTypes.shape({
//       id: PropTypes.number.isRequired,
//     }),
//   }).isRequired,
//   getActivityType: PropTypes.func.isRequired,
//   submitAction: PropTypes.func.isRequired,
//   navigate: PropTypes.func.isRequired,
// };

// export default NonPatientActivityTypeEdit;
